import {gsap} from 'gsap'
import CustomEase from 'gsap/CustomEase'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)
gsap.registerPlugin(CustomEase)
let splitTextInstances = [];

window.textScroll = (selector) => {
  let texts;

  if (selector) {
    texts = document.querySelectorAll(selector);
    if (!texts.length) {
      return false;
    }
  } else {
    texts = document.querySelectorAll('[data-rotate-in-animate] h1, [data-rotate-in-animate] .h1');
    if (!texts.length) {
      return false;
    }
  }

  const clearTextAnimation = () => {
    if (splitTextInstances.length > 0) {
      splitTextInstances.forEach(instance => {
        instance.revert();
      });
      splitTextInstances = [];
    }
  }
  clearTextAnimation();


  texts.forEach(text => {
    const splitTextInstance = new SplitText(text, {
      type: "lines, words, chars",
      linesClass: "split-line",
      charsClass: 'split-char',
      position: 'relative',
      reduceWhiteSpace: false
    });
    splitTextInstances.push(splitTextInstance); // Store reference to each SplitText instance

  });
}

window.splitLinesAnimate = (selector) => {
  let texts;
  if (selector) {
    texts = document.querySelectorAll(selector);
    if (!texts.length) {
      return false;
    }
  } else {
    texts = document.querySelectorAll('[data-rotate-in-animate] h1, [data-rotate-in-animate] .h1');
    if (!texts.length) {
      return false;
    }
  }
  gsap.utils.toArray("[data-rotate-in-animate]").forEach(textBlock => {
    const splitLines = textBlock.querySelectorAll('.split-char');
    const block = textBlock.querySelectorAll('[data-rotate-block]');
    const fadeIn = textBlock.querySelectorAll('[data-fade-in]');
    const mobileTexts = textBlock.querySelectorAll('.h1');
    const delayAnimation = textBlock.classList.contains('js--animate-later')
    gsap.set(splitLines, {opacity: 0, y: 10, rotateX: -90});
    gsap.set(block, {opacity: 0, rotateX: -20, scaleZ: 0.8, y: 150});
    gsap.set(fadeIn, {opacity: 0});
    gsap.set(texts, {opacity: 1});
    gsap.set(mobileTexts, {opacity: 1});

    ScrollTrigger.create({
      trigger: textBlock,
      // markers: true,
      scrub: true,
      start: delayAnimation ? "top-=20% center" :  "top-=20% bottom",
      end: 'bottom bottom',
      once: true,
      onEnter: () => {
        gsap.to(splitLines, {opacity: 1, duration: 0.4, stagger: 0.01});
        gsap.to(splitLines, {
          rotateX: 0,
          y: 0,
          duration: 0.6,
          stagger: 0.01,
          ease: CustomEase.create("custom", "M0,0 C0.435,0.25 0.15,0.965 1,1 ")
        });

        gsap.to(block, {opacity: 1, duration: 0.2});
        gsap.to(block, {rotateX: 1, scaleZ: 1, y: 0, duration: 0.8});

        gsap.to(fadeIn, {opacity: 1, delay: 0.65, duration: 0.25});
      }
    });
  });
}

$(window).on('load', function () {
  setTimeout(function () {
    textScroll()
    splitLinesAnimate()
  }, 1000)
})
